import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class LanguageImporter  {
    _originalTypeClassName = "zERP.BO.LanguageImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
LanguageImporter.translate = translateService;
}
this.LanguageImporterKey = null;
this._key = this.LanguageImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _LanguageImporterKey:any;
get LanguageImporterKey(): any {
    return this._LanguageImporterKey;
  }
set LanguageImporterKey(value: any) {
    this._LanguageImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.LanguageImporterKey == null || $this.LanguageImporterKey == 0;
            }


}